import { z } from 'zod'

import { PriceType, Status, TicketComboType } from '@/api/_schemas/management'

const ProductBaseSchema = z.object({
  nome: z.string().min(1, 'Produto obrigatório'),
  produto_pai: z.number().nullable(),
  produto_pai_nome: z.string(),
  imagem: z.string().nullable().optional(),
  situacao: z.enum([Status.Ativo, Status.Inativo]),
  tipo: z.number(),
  consumo: z.boolean(),
  permitir_observacao: z.boolean(),
  servico: z.boolean(),
  vlr_custo: z.string().min(1, 'Valor obrigatório'),
  tipo_valor: z.preprocess(
    (val) => {
      const num = typeof val === 'string' ? Number(val) : val
      return num === PriceType.Vazio ? undefined : num
    },
    z
      .nativeEnum(PriceType)
      .optional()
      .refine((val) => val !== undefined, {
        message: 'Tipo de valor obrigatório',
      }),
  ),
})

const ProductTaxSchema = z.object({
  cod_produto: z.number(),
  cod_externo: z.string().nullable().optional(),
  unidade_medida: z.string().nullable().optional(),
  cfop: z.string().nullable().optional(),
  ncm: z.string().nullable().optional(),
  icms_situacao_tributaria: z.string().nullable().optional(),
  icms_origem: z.string().nullable().optional(),
  icms_aliquota: z.string().nullable().optional(),
  icms_percentual_reducao_base_calculo: z.string().nullable().optional(),
  icms_modalidade_base_calculo: z.string().nullable().optional(),
  pis_situacao_tributaria: z.string().nullable().optional(),
  pis_tipo_tributacao: z.string().nullable().optional(),
  pis_aliquota_percentual: z.string().nullable().optional(),
  cofins_situacao_tributaria: z.string().nullable().optional(),
  cofins_tipo_tributacao: z.string().nullable().optional(),
  cofins_aliquota_percentual: z.string().nullable().optional(),
  cest: z.string().nullable().optional(),
  grupo_tributario: z.string().nullable().optional(),
})

const ProductComboSchema = z.object({
  tipo_ticket_combo: z.preprocess((val) => {
    const num = typeof val === 'string' ? Number(val) : val
    return num === TicketComboType.Vazio ? undefined : num
  }, z.nativeEnum(TicketComboType).nullable().optional()),
  produto_combo_list: z
    .array(
      z.object({
        cod_produto_combo: z.string().optional(),
        produto: z.string().optional(),
        produto_nome: z.string().optional(),
        qtde_produto: z.string(),
        vlr_produto: z.string(),
      }),
    )
    .optional(),
})

export const FormUpdateProductSchema = z
  .object({})
  .merge(ProductBaseSchema)
  .merge(ProductTaxSchema)
  .merge(ProductComboSchema)
  .superRefine((data, ctx) => {
    const isCombo = data.tipo === 3

    if (isCombo && !data.tipo_ticket_combo) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['tipo_ticket_combo'],
        message: 'Tipo ticket combo obrigatório',
      })
    }

    if (!isCombo && !data.unidade_medida) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['unidade_medida'],
        message: 'Unidade de medida obrigatória',
      })
    }
  })

export type FormUpdateProduct = z.infer<typeof FormUpdateProductSchema>
